import { render, staticRenderFns } from "./FileInboxOverview.vue?vue&type=template&id=e98a2938&scoped=true"
import script from "./FileInboxOverview.vue?vue&type=script&lang=ts"
export * from "./FileInboxOverview.vue?vue&type=script&lang=ts"
import style0 from "./FileInboxOverview.vue?vue&type=style&index=0&id=e98a2938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a2938",
  null
  
)

export default component.exports